app.service('wcOrderListView',function(){
	function init(){

	}
	return {
		init:init
	};
});
